<template>
    <div style="height: 100%; overflow-y: scroll; overflow-x: hidden;">
        <accettazione-ssn-anagrafica-component ref="cmpAnagraficaComponent" :isEdit="isEdit"
            :tipologiaRicetta="tipologiaRicetta" @beforeLoadData="onBeforeLoadData" @changeJsonData="onChangeJsonData"
            @afterLoadData="onAfterLoadData" />
    </div>
</template>

<script>
/* eslint-disable */

import AccettazioneSsnRicettaComponent from "./AccettazioneSsnRicettaComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
import AccettazioneSsnRicettaEditModalComponent from "./AccettazioneSsnRicettaViewModalComponent.vue";
import AccettazioneSsnRicettaPrestazioniComponent from "./AccettazioneSsnRicettaPrestazioniComponent.vue";
import AccettazioneSsnImpegnativaComponent from "./AccettazioneSsnImpegnativaComponent.vue";
import AccettazioneSsnAnagraficaComponent from "./AccettazioneSsnAnagraficaComponentN.vue";
import StepComponent from "../utility/StepComponent.vue";
import FormIndirizzoComponent from "../utility/FormIndirizzoComponent.vue";
import toast from "../../../../template/layout/utility/sa-toast";
export default {
    components: {
        AccettazioneSsnRicettaComponent,
        AccettazioneSsnRicettaPrestazioniComponent,
        AccettazioneSsnAnagraficaComponent,
        AccettazioneSsnRicettaEditModalComponent,
        AccettazioneSsnImpegnativaComponent,
        DatePicker,
        StepComponent,
        FormIndirizzoComponent,
    },
    mixins: { UtilityMixin },
    props: {
        isEdit: {
            type: Boolean,
            default: () => {
                return false;
            },
        },
        tipologiaRicetta: {
            type: String,
            required: false,
            default: () => {
                return null;
            },
        }
    },

    data() {
        return {
            isConfermaAnagrafica: false,
            pathResource: "/gestionericette",
            keyList: 0,
            statoCivileOptions: [],
            steps: ["Anagrafica", "Impegnativa", "Riepilogo"],
            tipologiaDocumentoOptions: ["Carta d'identita'", "Passaporto", "Patente di guida"],
            rilasciatoDaOptions: ["Ministero dell'Interno", "IPZS", "Comuni", "Polizia di Stato", "Altre Pubbliche Amministrazioni"],
            jsonData: {
                cittadinanza: null,
                statoCivile: null,
                anonimato: true,
                stp: false,
                eni: true,
                conv: false,
                team: true,
                emailBox: true,
                sconosciuto: false,
                noteCaratteristichePaziente: null,
                rilasciatoDa: null,
                documento: null,
                partitaIva: null,
                identificazioneIstituzione: null,
                tipologiaDocumento: null,
                identificazioneTessera: null,
                scadenzaStpEni: 0,
                scadenzaTessera: null,
                note: "",
            },
            fieldImpegnativeDettaglio: [
                {
                    label: "NRE",
                    key: "nre",
                },
                {
                    label: "C.F Assistito",
                    key: "codiceFiscaleAssistito",
                },
                {
                    label: "Priorita",
                    key: "classePriorita",
                },

                {
                    label: "Importo Totale",
                    key: "importoTotale",
                },
            ],

        };
    },
    computed: {},
    mounted() {
        if (this.tipologiaRicetta != null) {
            this.jsonData.tipologiaRicetta = this.tipologiaRicetta;
        }
        this.keyList++;
    },
    methods: {
        init(jsonData) {
            this.jsonData = jsonData;
            this.$refs.cmpAnagraficaComponent.init(this.jsonData);
        },

        onRicercaAssistito() {
            console.log("ricerca su sistema ts ?");

        },

        onBeforeLoadData() {
            let me = this;
            me.$emit("beforeLoadData");
            toast.error("Errore")
        },
        onReload() {
            let me = this;
            me.$emit("reload");
        },
        onAfterLoadData() {
            let me = this;
            me.$emit("afterLoadData");
        },
        onOpenModalImpegnativa() {
            let me = this;
            me.$emit("onOpenModalImpegnativa");
        },
        onClickBtnStruttura() {
            this.$emit("onOpenModalStruttura");
        },

        submit() {
            alert("Form inviato!");
        },
        calcolaImportoTotale(row) {
            let totale = 0;
            if (row.item.prestazioni) {
                for (let pre of row.item.prestazioni) {
                    totale += pre.prezzo;
                }
            }
            return totale;
        },
        onChangeAccettazioneImpegnativa(ricette) {
            this.$emit("changeJsonDataImpegnative", ricette);
        },
        onAggiungiImpegnativa(json) {
            let me = this;
            me.$emit("onAggiungiImpegnativa", json);
        },

        onChangeJsonData(json) {
            console.log("json", json);

            this.$emit("changeJsonData", json);
        },
    },
    watch: {
        // jsonData: {
        //     handler(json) {
        //         let me = this;
        //         me.setLocalData(json);
        //     },
        //     deep: true,
        //     immediate: true,
        // },
    },
};
</script>

<style scoped>
.active-class-step {
    border: 2px solid rgb(21, 155, 207) !important;
    background-color: white;
    border-radius: 50%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgb(21, 155, 207) !important;
    box-shadow: 0 0 10px rgba(21, 155, 207, 0.3);
    transition: all 0.2s ease-in-out;
}

.ft-step {
    font-weight: 700;
    font-size: 16px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f0f0f0;
    color: #555;
    margin: 10px;
    transition: all 0.3s ease-out;
    margin-bottom: 25px;
}
</style>
